<template>
    <div id="accordionExample">
    <b-card class="modal-requeteIn"> 
    <b-row no-gutters>
          <b-col lg="9" md="7">
            <b-card-text class ="pt-2 pb-2">
              <div class="titreRequete pr-2">{{requete.titre}}</div>
            </b-card-text>
          </b-col>
            <b-button pill align-self="center" title= "visualiser les informations de la requête"
            data-toggle="collapse" :data-target="'#collapse' + requete.idRequete" aria-expanded="true" :aria-controls="'#collapse' + requete.idRequete" class="nav-link1">visualiser <i class="fas fa-eye"></i></b-button>

            <b-button pill id="suppRequete" type="submit" v-on:click="emitDeleteRequeteFromJeu" title= "supprimer la requête"
            class="nav-link2">supprimer <i class="fas fa-trash-alt"></i>
            </b-button>

        </b-row>

      <div :id="'collapse' + requete.idRequete"  class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
            <p><strong>description</strong> : {{requete.description}}</p>
        </div>
    </b-card>
    </div>

</template>

<script>
import eventBus from '@/eventBus.js'

export default {
    name: 'RequeteItem',

    props: {  
        requete:{
            required:true,
            type:Object
        },
        idJeuRequetes:{
          type:Number
        }
    },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props){
    const emitDeleteRequeteFromJeu = () => {
      const idRequeteToDelete = props.requete.idRequete;
      const idJeuToSend = props.idJeuRequetes;
      eventBus.emit('deleteRequeteFromJeu' + idJeuToSend.toString(), idRequeteToDelete, idJeuToSend);
    };

    return {
      emitDeleteRequeteFromJeu,
    };
  },
};
</script>

<style>
.nav-link1{
  color: white !important;
  font-size: 25px;
}
.nav-link1:hover{
  color: black !important;
}
.titreRequete{
  color: black;
  font-size: 20px;
}
.description{
  color: black;
}

.modal-requeteIn {

  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  font-family: Helvetica, Arial, sans-serif;
}
</style>